/* eslint-disable no-return-assign */
// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import AsyncStorage from '@react-native-community/async-storage';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { Config } from '../../constants/Config';
import { AppConfig } from '../../shared/AppConfig';
import { TAGS } from './tags.enum';

// initialize an empty api service that we'll inject endpoints into later as needed

const dynamicBaseQuery = async (args, WebApi, extraOptions) => {
  const partnerId = AppConfig.REACT_APP_REFUEL_PARTNER;
  const localBaseUrl = await AsyncStorage.getItem('selectedServer');
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: localBaseUrl || AppConfig.REACT_APP_BASE_URL || 'http://dev.service.recykal.com',
    prepareHeaders: (headers, { getState }) => {
      const {
        consumer: { token },
      } = getState();
      headers.set('Content-Type', 'application/json');
      headers.set('appCode', Config.CONSUMER_APP_CODE);
      headers.set('partnerId', partnerId);
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });
  return rawBaseQuery(args, WebApi, extraOptions);
};

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await dynamicBaseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    // try to get a new token
  } else if (result.error && result.error.status === 400) {
    // try to get a new token
    global.toast.show(
      result.error.data?.title || result.error.data?.message || 'Something went wrong.',
      { type: 'danger' }
    );
  } else if (result.error && result.error.status === 500) {
    // try to get a new token
    global.toast.show(
      result.error.data?.title || result.error.data?.message || 'Something went wrong.',
      { type: 'danger' }
    );
  }
  return result;
};

export const backendApi = createApi({
  reducerPath: 'backend',
  overrideExisting: true,
  // extractRehydrationInfo(action, { reducerPath }) {
  //   if (action.type === REHYDRATE) {
  //     return action.payload[reducerPath];
  //   }
  // },
  baseQuery: baseQueryWithReauth,
  // refetchOnMountOrArgChange: 30,
  tagTypes: [TAGS.CONSUMER_CART, TAGS.TOKEN_CHANGED],
  endpoints: () => ({}),
});
